import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import { Toggler } from '@kiper/ui';
import colors from '@kiper/theme/colors';
import { PersonalizedInviteProvider } from '../../../../../../store/PersonalizedInvite';
import PersonalizedInvite from '../../../PersonalizedInvite';
import { HEX_COLOR } from '../../utils/validateGeneratorForm';
import bannerPorterInvite from '../../../../../../assets/images/banner-porter-invite.png';
import logoPorter from '../../../../../../assets/images/logo-porter.svg';
import fakeGuestFace from '../../../../../../assets/images/personalized-invite/fake-guest-face.svg';
import * as S from './styles';

// Cor inválida quebra o cálculo de contraste do convite (chroma-js)
const toValidColor = (color, fallback) =>
  HEX_COLOR.test(color) ? color : fallback;

const InvitePreview = ({ values, logoUrl, bannerUrl }) => {
  const [t] = useTranslation('personalized-invite');
  const [isFaceRegistered, setIsFaceRegistered] = useState(false);

  const handleToggleFaceRegistered = () =>
    setIsFaceRegistered(previous => !previous);

  const previewInvite = {
    inviteTitle: t('generator.preview.sample.title'),
    eventDate: t('generator.preview.sample.start'),
    eventEndDate: t('generator.preview.sample.end'),
    location: {
      name: t('generator.preview.sample.location-name'),
      address: t('generator.preview.sample.location-address'),
      mapsUrl: '',
    },
    destination: t('generator.preview.sample.destination'),
    customization: {
      primaryColor: toValidColor(values.primaryColor, colors.porterSecondary),
      secondaryColor: toValidColor(values.secondaryColor, colors.porterPrimary),
      logoUrl: logoUrl || logoPorter,
      bannerImageUrl: bannerUrl || bannerPorterInvite,
      bannerPosition: `center ${values.bannerFocus}%`,
    },
    hostMessage: values.hostMessage.trim() || null,
    condominiumNotice: values.condominiumNotice.trim() || null,
    hasFacialRegistered: isFaceRegistered,
    previewFacePhotoUrl: fakeGuestFace,
    userName: t('generator.preview.sample.guest-name'),
  };

  return (
    <S.Wrapper>
      <Toggler
        id="faceRegistered"
        label={t('generator.preview.face-registered')}
        checked={isFaceRegistered}
        onChange={handleToggleFaceRegistered}
      />
      <S.PhoneFrame>
        {/* React 17 não reconhece inert como booleano: a string vazia liga o atributo */}
        <S.InertContent inert="" aria-hidden="true">
          <PersonalizedInviteProvider inviteData={previewInvite}>
            <PersonalizedInvite />
          </PersonalizedInviteProvider>
        </S.InertContent>
      </S.PhoneFrame>
    </S.Wrapper>
  );
};

InvitePreview.propTypes = {
  values: propTypes.shape({
    primaryColor: propTypes.string,
    secondaryColor: propTypes.string,
    bannerFocus: propTypes.number,
    hostMessage: propTypes.string,
    condominiumNotice: propTypes.string,
  }).isRequired,
  logoUrl: propTypes.string,
  bannerUrl: propTypes.string,
};

InvitePreview.defaultProps = {
  logoUrl: '',
  bannerUrl: '',
};

export default InvitePreview;
